export enum LogType {
    User = 1,
    Group = 2,
    Entity = 3,
    Asset = 4,
    Workflow = 5,
    EmailTemplate = 6
}

export enum OperationType {
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export class ActivityLog {
    Id: string;
    Date: Date;
    User: string;    
    TableName: string;
    OperationType: OperationType;
    OldValue: string;
    NewValue: string;
}
